import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between q-py-lg background-gray section-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-title" }, "Dashboard", -1)
const _hoisted_3 = { class: "section-container q-pt-lg" }
const _hoisted_4 = { class: "page-subtitle" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-grow col-sm-12 col-xs-12" }
const _hoisted_7 = { class: "mobile-display-block__wrap" }
const _hoisted_8 = { class: "row mobile-display-block dash-container q-ml-md" }
const _hoisted_9 = { class: "dash-block col-12" }
const _hoisted_10 = { class: "dash-block__caption" }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "q-mr-sm text-weight-bold dash-block__value" }
const _hoisted_13 = { class: "dash-block col-12" }
const _hoisted_14 = { class: "dash-block__caption" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = { class: "q-mr-sm text-weight-bold dash-block__value" }
const _hoisted_17 = { class: "dash-block col-12" }
const _hoisted_18 = { class: "dash-block__caption" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "q-mr-sm text-weight-bold dash-block__value" }
const _hoisted_21 = { class: "dash-block col-12" }
const _hoisted_22 = { class: "dash-block__caption" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "q-mr-sm text-weight-bold dash-block__value" }
const _hoisted_25 = { class: "dash-block col-12" }
const _hoisted_26 = { class: "dash-block__caption" }
const _hoisted_27 = { class: "flex items-center" }
const _hoisted_28 = { class: "q-mr-sm text-weight-bold dash-block__value" }
const _hoisted_29 = {
  key: 0,
  class: "line-chart-container"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_ExpandableFilters = _resolveComponent("ExpandableFilters")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_q_btn, {
          "no-caps": "",
          "icon-right": _ctx.heroOutline24ArrowDownTray,
          class: "q-btn__main-size text-weight-bold",
          label: "Export",
          color: "primary",
          outline: "",
          onClick: _ctx.exportChartData
        }, null, 8, ["icon-right", "onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('overview')) + ": " + _toDisplayString(_ctx.$t('clicks')) + " / " + _toDisplayString(_ctx.$t('regs')) + " / " + _toDisplayString(_ctx.$t('deps')), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_ExpandableFilters, {
            onReset: _ctx.resetFilters,
            onChange: _ctx.onChangeFilters,
            onChangeAll: _ctx.changeAll,
            onExport: _ctx.onExport,
            "current-filters": _ctx.filters
          }, null, 8, ["onReset", "onChange", "onChangeAll", "onExport", "current-filters"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_LineChart, {
              rows: _ctx.chartData,
              groupBy: _ctx.filters.groupBy,
              columns: _ctx.selectedColumns,
              allColumns: _ctx.columns,
              groupByOptions: _ctx.getGroupByArray(),
              loading: _ctx.chartLoading,
              "export-data": _ctx.isExportChartData
            }, null, 8, ["rows", "groupBy", "columns", "allColumns", "groupByOptions", "loading", "export-data"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('clicks')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.dashboardTotal.clicks), 1),
                  _createElementVNode("span", {
                    class: "dash-block__percent reward_amount",
                    style: _normalizeStyle(
                    _ctx.dashboardTotal.clicksDelta > 0
                      ? 'color: #1cc928; border-color: #1cc928'
                      : _ctx.dashboardTotal.clicksDelta === 0
                      ? 'color: #FFD000; border-color: #FFD000;'
                      : 'color: #D03636; border-color: #D03636;'
                  )
                  }, _toDisplayString(_ctx.dashboardTotal.clicksDelta > 0
                      ? `+${Math.round(_ctx.dashboardTotal.clicksDelta)}%`
                      : `${Math.round(_ctx.dashboardTotal.clicksDelta)}%`), 5),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      size: "xs",
                      name: _ctx.heroOutline24InformationCircle
                    }, null, 8, ["name"]),
                    _createVNode(_component_q_tooltip, { anchor: "bottom right" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Percentage change between the previous and selected period.")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('uniqs')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dashboardTotal.uniqueClicks), 1),
                  _createElementVNode("span", {
                    class: "dash-block__percent reward_amount",
                    style: _normalizeStyle(
                    _ctx.dashboardTotal.uniqueClicksDelta > 0
                      ? 'color: #1cc928; border-color: #1cc928'
                      : _ctx.dashboardTotal.uniqueClicksDelta === 0
                      ? 'color: #FFD000; border-color: #FFD000;'
                      : 'color: #D03636; border-color: #D03636;'
                  )
                  }, _toDisplayString(_ctx.dashboardTotal.clicksDelta > 0
                      ? `+${Math.round(_ctx.dashboardTotal.uniqueClicksDelta)}%`
                      : `${Math.round(_ctx.dashboardTotal.uniqueClicksDelta)}%`), 5),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      size: "xs",
                      name: _ctx.heroOutline24InformationCircle
                    }, null, 8, ["name"]),
                    _createVNode(_component_q_tooltip, { anchor: "bottom right" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Percentage change between the previous and selected period.")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('regs')), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.dashboardTotal.registrationCount), 1),
                  _createElementVNode("span", {
                    class: "dash-block__percent reward_amount",
                    style: _normalizeStyle(
                    _ctx.dashboardTotal.registrationCountDelta > 0
                      ? 'color: #1cc928; border-color: #1cc928'
                      : _ctx.dashboardTotal.registrationCountDelta === 0
                      ? 'color: #FFD000; border-color: #FFD000;'
                      : 'color: #D03636; border-color: #D03636;'
                  )
                  }, _toDisplayString(_ctx.dashboardTotal.clicksDelta > 0
                      ? `+${Math.round(_ctx.dashboardTotal.registrationCountDelta)}%`
                      : `${Math.round(_ctx.dashboardTotal.registrationCountDelta)}%`), 5),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      size: "xs",
                      name: _ctx.heroOutline24InformationCircle
                    }, null, 8, ["name"]),
                    _createVNode(_component_q_tooltip, { anchor: "bottom right" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Percentage change between the previous and selected period.")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('first_dep')), 1),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.dashboardTotal.firstDepositCount), 1),
                  _createElementVNode("span", {
                    class: "dash-block__percent reward_amount",
                    style: _normalizeStyle(
                    _ctx.dashboardTotal.firstDepositCountDelta > 0
                      ? 'color: #1cc928; border-color: #1cc928'
                      : _ctx.dashboardTotal.firstDepositCountDelta === 0
                      ? 'color: #FFD000; border-color: #FFD000;'
                      : 'color: #D03636; border-color: #D03636;'
                  )
                  }, _toDisplayString(_ctx.dashboardTotal.clicksDelta > 0
                      ? `+${Math.round(_ctx.dashboardTotal.firstDepositCountDelta)}%`
                      : `${Math.round(_ctx.dashboardTotal.firstDepositCountDelta)}%`), 5),
                  _createElementVNode("div", null, [
                    _createVNode(_component_q_icon, {
                      size: "xs",
                      name: _ctx.heroOutline24InformationCircle
                    }, null, 8, ["name"]),
                    _createVNode(_component_q_tooltip, { anchor: "bottom right" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Percentage change between the previous and selected period.")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('income')), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(`${_ctx.baseCurrency} ${_ctx.dashboardTotal.profit}`), 1)
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.$q.screen.width > 600)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}